import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { PdfInterventiService } from './pdf-interventi.service';
import { TestataIntervento } from 'src/app/common/models/Intervento';
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import { Base64BlobUtils } from 'src/app/common/utilities/Base64BlobUtils';

@Injectable({
  providedIn: 'root'
})
export class MemorizzatoreRapportiniService {
  private appNamedDir = 'INTEGRA_SERVICE_APP';

  constructor(
    private platform: Platform,
    private pdfInterventi: PdfInterventiService) {
  }

  async saveSignedReport(intervento: TestataIntervento, pdfContentB64: string) {
    const fileName = this.pdfInterventi.getFileName(intervento);
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.saveFileMobile(fileName,pdfContentB64);
    } else {
      this.saveFileWeb(fileName,pdfContentB64);
    }
  }

  private async saveFileMobile(fileName: string, pdfContentB64: string){
    // Check se la directory esiste
    const directoryExists = await this.directoryExists(this.appNamedDir);
    if (!directoryExists) {
      // Crea la directory se non esiste
      await Filesystem.mkdir({
        path: this.appNamedDir,
        directory: Directory.Documents,
      });
    }

    console.log(`Inizia salvataggio file Pdf ${fileName} in ${Directory.Documents}`);
    try {
      await Filesystem.writeFile({
        path: `${this.appNamedDir}/${fileName}`,
        data: pdfContentB64,
        directory: Directory.Documents, //file:///storage/emulated/0/Documents/
      });
      
      console.log('File rapportino salvato');
    } catch (error) {
      console.error('Errore in salvataggio su file system del rapportino', error);
      throw error;
    } 
  }

  private async saveFileWeb(fileName: string, pdfContentB64: string){
    const mimeType = 'application/pdf';
    const blob = await Base64BlobUtils.base64ToBlob(pdfContentB64, mimeType);
    const fileAsUrl = window.URL.createObjectURL(blob);
    const anchor = window.document.createElement('a'); // Triggero l'apertura del download aprendo la risorsa in un <a>
    anchor.href = fileAsUrl;
    anchor.download = fileName;
    anchor.style.visibility = 'hidden';
    document.body.appendChild(anchor);
    anchor.click(); //download file
    document.body.removeChild(anchor);
    URL.revokeObjectURL(fileAsUrl); // pulisco la memoria
  }

  private async directoryExists(path: string): Promise<boolean> {
    try {
      // Utilizzo Filesystem.stat per ottenere informazioni sulla directory
      const directoryStat = await Filesystem.stat({
        path,
        directory: Directory.Documents,
      });
  
      // Controlla se il percorso corrisponde a una directory
      return directoryStat.type === 'directory';
    } catch (error) {
      // Se si verifica un errore, la directory non esiste
      return false;
    }
  }
}